import refs from '../helpers/refs'

const TOP_LEVEL_BLOCK_SELECTOR = '& > p, & > h1, & > h2, & > h3, & > h4, & > h5'
const TOP_LEVEL_BLOCK_ELEMENTS = 'p, h1, h2, h3, h4, h5'

class WYSIWYG {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // Full width images and 2-3 images side-by-side
    // Disabled due to image stretching issues it causes in some articles and not handling some cases of side-by-side images, replaced with CSS solution in s-wysiwyg.pcss
    // this.setupSideBySideImages()

    // Fix tables - make them scrollable on mobile
    this.fixTables()
  }

  popImages (images) {
    if (images.length === 0) { return }

    // Top-level block of the last image (keep track of this so we know where to insert the new div)
    const lastBlock = images[images.length - 1].closest(TOP_LEVEL_BLOCK_ELEMENTS)

    if (!lastBlock) {
      console.warn('Could not find top-level block for image', images[images.length - 1])
      return
    }

    // Single image - still used for full-width images, ONLY if landscape
    if (images.length === 1) {
      const width = images[0].naturalWidth
      const height = images[0].naturalHeight
      const ratio = width / height

      if (ratio < 1.5) {
        // Image is portrait, do not make full width
        images = []
        return
      }
    }

    // Create a new div to hold the images
    const div = document.createElement('div')
    div.className = 'w-full flex flex-col md:flex-row gap-4'
    div.style.minHeight = '550px'
    div.style.maxWidth = '1600px'

    // Add each image to the div
    images.forEach((img, index) => {
      const parentBlock = img.closest(TOP_LEVEL_BLOCK_ELEMENTS)

      img.classList.add('object-cover')
      img.remove()

      // Remove top-level block (unless it matches the block of the last image)
      if (parentBlock !== lastBlock) {
        parentBlock.remove()
      }

      div.appendChild(img)

      // Set the width of each image according to the total number of images
      img.classList.add('w-full')
      switch (images.length) {
        case 2:
          img.classList.add((index === 0) ? 'md:w-2/3' : 'md:w-1/3')
          break
        case 3:
          img.classList.add((index === 0) ? 'md:w-1/2' : 'md:w-1/4')
          break
        default:
          img.style.width = 100 / images.length + '%'
      }
    })

    // Insert the div after the block of the last image
    lastBlock.insertAdjacentElement('afterend', div)

    // Remove the last block
    // We do not just put the new div inside this block, because the side-by-side is full-width
    lastBlock.remove()

    // Reset the images array
    images = []
  }

  setupSideBySideImages () {
    const topLevelBlocks = Array.from(this.$root.querySelectorAll(TOP_LEVEL_BLOCK_SELECTOR))
    let sideBySideImages = []

    for (const block of topLevelBlocks) {
      // If the block has text, skip it, the wysiwyg editor separates text and images into separate blocks
      if (block.textContent.trim().length > 0) {
        this.popImages(sideBySideImages)
        // Reset the sideBySideImages array
        sideBySideImages = []
        continue
      }

      // If the block has no images, skip it
      const images = Array.from(block.querySelectorAll('img'))

      if (images.length === 0) {
        this.popImages(sideBySideImages)
        continue
      }

      // Images found, add them to the sideBySideImages array
      if (images.length > 0) {
        sideBySideImages.push(...images)
      }
    }

    this.popImages(sideBySideImages)
  }

  fixTables () {
    this.$root.querySelectorAll('& > table').forEach((table) => {
      const div = document.createElement('div')
      div.className = 'overflow-x-auto'
      table.parentNode.insertBefore(div, table)
      div.appendChild(table)
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.s-wysiwyg')
    .forEach(el => new WYSIWYG(el))
})
